import * as THREE from 'three';
import type { ItemId } from '../config/gameConfig';

export type InteractKind =
  | 'examine'
  | 'pickup'
  | 'door'
  | 'drawer'
  | 'clock'
  | 'safe'
  | 'valves'
  | 'fusebox'
  | 'wires'
  | 'mirrors'
  | 'exit'
  | 'use_item'
  | 'fireplace'
  | 'bookshelf'
  | 'piano'
  | 'cabinet'
  | 'pressure'
  | 'brazier'
  | 'sheet_music';

export interface InteractableData {
  id: string;
  kind: InteractKind;
  title: string;
  body?: string;
  prompt?: string;
  itemId?: ItemId;
  requires?: ItemId;
  locked?: boolean;
  mesh: THREE.Object3D;
  meta?: Record<string, unknown>;
}

export function makeInteractable(
  mesh: THREE.Object3D,
  data: Omit<InteractableData, 'mesh'>,
): InteractableData {
  mesh.userData.interactable = true;
  mesh.userData.interactId = data.id;
  return { ...data, mesh };
}
